/**
 * Invitation types that show a scoped preview screen before signup.
 * Used by auth-stack.web.tsx (entry routing) and app-stack.web.tsx
 * (post-auth navigation) — both must stay in sync.
 *
 * To add a new type: append it here, then implement the preview layout
 * in InvitationPreview.web.tsx and the post-auth navigation branch in
 * app-stack.web.tsx.
 */
export const SCOPED_INVITE_TYPES: string[] = ['project', 'task'];
